import React, { useEffect } from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { captureExceptionWithTeam } from 'Utilities/captureException/captureExceptionWithTeam';
import { TEAM } from 'Utilities/constants';
import { formatPhoneNumber } from 'Utilities/helpers';

import { FiguresBox } from '../components/FiguresBox/FiguresBox';
import { PHONES } from '../Payments.helpers';
import LocalTexts from '../Payments.text.json';

const LocalT = new MDText(LocalTexts.payments.hardError);

const PaymentHardError = () => {
  useEffect(() => {
    captureExceptionWithTeam('[PaymentHardError] page displayed', TEAM.PAYMENTS_FE, {
      level: 'info',
    });
  }, []);

  return (
    <div>
      <FiguresBox
        buttons={
          <Button
            reverse
            as="a"
            href={`tel:${PHONES.PAYMENT_ERROR}`}
            icon="phone"
            label={`${formatPhoneNumber(PHONES.PAYMENT_ERROR).pretty}`}
          />
        }
        content={
          <p>{LocalT.translate('desc')}</p>
        }
        icon='error'
        title={`${LocalT.translate('title')}`}
      />
    </div>
  );
};

export { PaymentHardError };
